export default {
  'operationLog.title': 'Registro de Operaciones',
  'operationLog.filter.timeRange': 'Hora de Operación',
  'operationLog.filter.loginName': 'Operador',
  'operationLog.filter.loginNamePlaceholder': 'Nombre de inicio de sesión',
  'operationLog.filter.menuId': 'Menú',
  'operationLog.filter.menuIdPlaceholder': 'Busque o seleccione un menú',
  'operationLog.menuNone': 'NINGUNO',
  'operationLog.filter.requestUrl': 'URL de Solicitud',
  'operationLog.filter.requestUrlPlaceholder': 'Búsqueda difusa, p. ej. /user/mgmt',
  'operationLog.filter.requestMethod': 'Método',
  'operationLog.filter.rsCode': 'Código de Respuesta',
  'operationLog.filter.clientIp': 'IP del Cliente',
  'operationLog.filter.serviceName': 'Servicio',
  'operationLog.filter.traceId': 'TraceId',
  'operationLog.filter.search': 'Buscar',
  'operationLog.filter.reset': 'Restablecer',
  'operationLog.col.operationTime': 'Hora de Operación',
  'operationLog.col.loginName': 'Operador',
  'operationLog.col.systemName': 'Nombre',
  'operationLog.superAdmin': 'Superadministrador',
  'operationLog.col.menu': 'Menú',
  'operationLog.col.serviceName': 'Servicio',
  'operationLog.col.requestMethod': 'Método',
  'operationLog.col.requestUrl': 'URL de Solicitud',
  'operationLog.col.rsCode': 'Código de Respuesta',
  'operationLog.col.rsMessages': 'Mensaje de Respuesta',
  'operationLog.col.clientIp': 'IP del Cliente',
  'operationLog.col.durationMs': 'Duración(ms)',
  'operationLog.col.traceId': 'TraceId',
  'operationLog.col.detail': 'Detalle',
  'operationLog.detail.title': 'Detalle del Registro de Operaciones',
  'operationLog.detail.basic': 'Básico',
  'operationLog.detail.userAgent': 'User-Agent',
  'operationLog.detail.requestParams': 'Parámetros de Solicitud',
  'operationLog.detail.responseSummary': 'Resumen de Respuesta',
  'operationLog.detail.exceptionMsg': 'Excepción',
  'operationLog.fetchError': 'Consulta fallida, por favor reintente',
};
